exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (max-width:37.4rem){.DialogFrames_hide-sm__31WAW{display:none!important}}@media (min-width:37.4rem){.DialogFrames_visible-sm__2yIR8{display:none!important}}@media (max-width:79.9rem){.DialogFrames_hide-md__3Zk03{display:none!important}}@media (min-width:79.9rem){.DialogFrames_visible-md__BeoMB{display:none!important}}.DialogFrames_frame__3Bpma{position:fixed;background:#fff;display:flex;flex-direction:column}.DialogFrames_fullscreen__2mX8f{top:0;left:0;right:0;bottom:0}.DialogFrames_huge__3CxJU{top:5%;left:5%;bottom:5%;right:5%;box-shadow:0 14px 45px rgba(0,0,0,.25),0 10px 18px rgba(0,0,0,.22);border-radius:2px}@media (max-width:37.4rem){.DialogFrames_huge__3CxJU{top:0;left:0;bottom:0;right:0}}", ""]);

// exports
exports.locals = {
	"hide-sm": "DialogFrames_hide-sm__31WAW",
	"hideSm": "DialogFrames_hide-sm__31WAW",
	"visible-sm": "DialogFrames_visible-sm__2yIR8",
	"visibleSm": "DialogFrames_visible-sm__2yIR8",
	"hide-md": "DialogFrames_hide-md__3Zk03",
	"hideMd": "DialogFrames_hide-md__3Zk03",
	"visible-md": "DialogFrames_visible-md__BeoMB",
	"visibleMd": "DialogFrames_visible-md__BeoMB",
	"frame": "DialogFrames_frame__3Bpma",
	"fullscreen": "DialogFrames_fullscreen__2mX8f",
	"huge": "DialogFrames_huge__3CxJU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/DialogLayout/Custom/DialogFrames.less
// module id = 2064
// module chunks = 8